import get from 'lodash/get';
import HydratorError from './error';
export const hydratePolymorphicData = (hydrators, data, captureException) => {
  if (data) {
    if ('__typename' in data) {
      const hydrator = hydrators[data.__typename];
      if (hydrator) {
        try {
          return hydrateData(data, hydrator);
        } catch (error) {
          captureException && captureException(new HydratorError({
            error,
            message: `Hydrator failed for [${data.__typename}].`
          }));
        }
      } else {
        captureException && captureException(new HydratorError({
          message: `Missing hydrator for [${data.__typename}].`
        }));
      }
    } else {
      captureException && captureException(new HydratorError({
        message: `Missing [__typename] field from data.`
      }));
    }
  }
  return null;
};
function getOrSearch(object, path) {
  if (!object) {
    return object;
  }
  if (path.includes(':')) {
    const [searchField, searchValue] = path.split(':');
    return findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, '') // Strip any preceding whitesepace and quotes
    );
  }
  return get(object, path);
}
function resolvePath(object, path) {
  // Split the path on each bracket
  const splitPath = path.split(/\(|\)./);

  // Traverse the split path as a tree, resolving as we go
  let current = object;
  for (const split of splitPath) {
    current = getOrSearch(current, split);
  }
  return current;
}
function findNodeByField(edges, fieldId, searchValue) {
  return edges.find(edge => get(edge, fieldId) === searchValue);
}
export function getValues(object, paths) {
  return paths.map(path => resolvePath(object, path));
}
const hydrateData = (data, hydrator) => {
  const {
    hydratorPaths,
    staticFallbacks
  } = hydrator;
  return {
    staticFallbacks,
    ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue]) => {
      const item = getValues(data, dataValue);
      if (item) {
        acc[key] = item;
      } else {
        throw new Error(`Bad hydrator path: ${key}`);
      }
      return acc;
    }, {})
  };
};